export default __webpack_public_path__ + "static/media/icon-close-red.becbc906.svg";